
import useUsuarioStore from "@/store/usuario";
import useRetiroStore from "@/store/retiro";
export default function useChatComponent(modelShow,modelo, modeloId) {

  const mensajes = ref([]);
 

 
  const usuarios = ref([]);

  const usuario_store = useUsuarioStore();

  const { usuario,usuario_id } = storeToRefs(usuario_store);

 const formulario = ref({
    model_id: computed(() => modeloId.value || null),
    model_type: computed(() => modelo.value || null),
    usuario_id: computed(() => usuario_id.value || null),
    mensaje: '',
 });
  const aperturado = ref(false);


  // Scroll to Bottom ChatLog
  const refChatLogPS = ref(null);

  // methods

  const enviar = (values, next = () => ({}), setErrors = () => ({})) => {
    try {
      if(modeloId.value) {
        if(modelo.value && modelo.value == `App\\Models\\Retiro`){

          const retiro_store = useRetiroStore();
          retiro_store.enviarMensaje(modeloId.value, {
            ...values,
            model_id: modeloId.value,
            model_type: modelo.value,
            usuario_id: usuario_id.value,
          }).then(({result}) => {
              if(result) {
                next();
                scrollToBottomInChatLog();
              }
          }).catch(e => {
            console.log("Error en enviar mensaje:", e);
            if(e.response && e.response.status === 422) {
              setErrors(e.response.data.errors);
            }
          })

        }else{
          throw new Error("No se puede enviar mensaje: modelo no soportado");
        }
      }else{
        throw new Error("No se puede enviar mensaje: modeloId no definido");
      }
       
    } catch (error) {
      throw error;
    }

  };

    

  const scrollToBottomInChatLog = () => {
    if(refChatLogPS.value == null) return;
    const scrollEl = refChatLogPS.value.$el || refChatLogPS.value;
    scrollEl.scrollTo({
      top: scrollEl.scrollHeight,
      behavior: "smooth",
    });

    // scrollEl.scrollTop = scrollEl.scrollHeight;
  };

  watch(refChatLogPS, () => {
    scrollToBottomInChatLog();
  });

  const cerrar = () => {
    mensajes.value = [];
    modelShow.value = false;
  };

  const aperturarChat = (next = () => ({})) => {

    let iform = document.querySelector(".input-form");

    if (iform) {
      iform.focus();
    }


    if(usuario_id.value){

      if(!modeloId.value) return null;

      if(modelo.value == `App\\Models\\Retiro`){
          const retiro_store = useRetiroStore();
          retiro_store.aperturarChat(modeloId.value)
          .then(({result,mensajes:msjs}) => {
            if(result){
              aperturado.value = true;
              mensajes.value = msjs;
              
              nextTick(() => {
                next();
                scrollToBottomInChatLog();
              });

            }
          })
      }
       
    }

  };

  const aperturarEcho = () => {

    if (modeloId.value) {
      if(modelo.value == `App\\Models\\Retiro`){
        Echo.join(`retiro.${modeloId.value}.chat`)
          .here((users) => {
            usuarios.value = users; // usuarios en el canal
          })
          .joining((user) => {
            usuarios.value.push(user);
            toast.success(`${user.fullname} se ha unido al chat.`);
          })
          .leaving((user) => {
            usuarios.value = usuarios.value.filter((u) => u.id !== user.id);
          })
          .listen(".nuevo-mensaje", ({ mensaje: msj }) => {
            if (
              msj.model_id == modeloId.value &&
              msj.model_type == modelo.value
            ) {
              mensajes.value.push(msj);
              nextTick(() => {
                scrollToBottomInChatLog();
              });
            }
          })
          .error((error) => {
            console.error("error en canal retiro.chat: ", error);
          });
      }
    }
  };


  const leaveChannel = () => {
    if(modelo.value == `App\\Models\\Retiro`){
      Echo.leave(`retiro.${modeloId.value}.chat`);
      aperturado.value = false;
      usuarios.value = [];
    } 
  };

  onMounted(() => {
    aperturarEcho();
  });


  watch(modelShow,(val) => {
    if(val) {
      aperturarChat(() => {
        aperturarEcho();
      })
    }else{
      leaveChannel();
    }
  })

  onUnmounted(() => {
    leaveChannel();
  });
  const esperandoRespuesta = ref(false);


  return {
    // state and getters
    modelShow,
    mensajes,
    formulario,
    usuario,
    usuarios,
    aperturado,
    refChatLogPS,
    esperandoRespuesta,
    // methods
    scrollToBottomInChatLog,
    cerrar,
    aperturarChat,
    leaveChannel,
    enviar
  };
}
